








































































































import { Component, Ref, Watch, Vue } from 'vue-property-decorator';
import { Action, Getter } from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { SelectWings } from "wings-ui-components";
import { notifyConfirm, notifyDelete, notifyError } from "@/utils/notify-helper";
import { RestrictionItem } from '@/store/sms/restrictions/types';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: { SelectWings }})
export default class OriginatorRestriction extends Vue {
  @Ref('validator') validator: any;

  @Getter("restrictionsList") restrictionsList: any;

  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getRestrictionItem") actionGetItem: any;
  @Action("saveRestriction") actionSave: any;
  @Action("deleteRestriction") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private selected = []
  private logObject: ActionLog = {};

  params = {transport: 'SMS'};
  serviceProvidersList:  any = []

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  defaultItem(): RestrictionItem {
    return {
      id:undefined,
      service_provider_id:undefined,
      restriction:undefined,
      originators:[]
    };
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "The rule for restricting originators",
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem(this.$route.params.id)
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"})
      }
      this.serviceProvidersList = await this.actionGetServiceProviders({id: this.item.service_provider_id});
    }
  }

  back():void{
    this.$router.push(`/sms/restrictions/`);
  }

  onSelect(items:any) {
    this.selected = items
  }

  addOriginator() {
    this.item.originators?.push({id: undefined, name: ''})
  }

  onDeleteOriginators() {
    this.selected.forEach(s => {
      this.removeItem(this.item.originators || [], s)
    })
    if (this.item.originators?.length === 0) {
      this.addOriginator();
    }
  }

  async onSaveItem():Promise<void> {
    const valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "The rule for restricting originators",
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave( this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error;
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      throw new Error();
    }
  }

  async onDeleteItem():Promise<void> {
    const isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "The rule for restricting originators",
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete( this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error;
      }
    }
  }

  @Watch('item.restriction')
  onRestrictionChange(val?: string, oldVal?: string) {
    if (val !== 'allowed') {
      this.item.originators = []
    } else if (this.item.originators?.length === 0) {
      this.item.originators?.push({id: undefined, name: ''})
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    const isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  private removeItem<T>(arr: Array<T>, value: T): Array<T> {
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
}
